import { EvaluateAgenticLogicRuleScenarioResponseBodyType } from "@intelligems/ig-types";
import { skipToken, useQuery } from "@tanstack/react-query";

import { agenticLogicKeys } from "../queryKeys";

/**
 * Reads the result of a cart run, keyed per scenario NAME (the wire carries no
 * scenario id).
 *
 * A READ, never a fetch: Atlas runs carts through its own tool and seeds the
 * answer here, so there is exactly one caller of the evaluate route and one
 * run per request. `skipToken` is what makes that explicit — this query
 * subscribes to the cache and can never start an evaluation of its own.
 *
 * The family is dropped on draft save — the one event that changes what an
 * evaluation would answer — which is how a run stops being shown once it no
 * longer describes the rule.
 */
export const useAgenticLogicScenarioEvaluation = (
  ruleId: string | undefined,
  scenarioName: string | null
) => {
  return useQuery<EvaluateAgenticLogicRuleScenarioResponseBodyType, Error>({
    queryKey: agenticLogicKeys.scenarioEvaluation(ruleId!, scenarioName ?? ""),
    queryFn: skipToken,
    enabled: !!ruleId && scenarioName !== null,
    staleTime: Infinity,
  });
};
